/*
 * @Author: zjw
 * @Date: 2021-05-25 17:30:53
 * @La
 * tEditTime: 2021-07-16 16:41:48
 * @FilePath: \web-app\src\mixins\common.js
 * @Environment: Vue + Element
 * @Description: 
 */
export default {
    components: {
        myDialog: () => import("@/components/content/myDialog"),
        myDialogDetail: () => import("@/components/content/myDialogDetail"),
    },
    watch: {
        selectedData: {
            //因为引用类型的原因，newValue和oldValue的值一直相等
            handler(val) {
                console.log(val);
            },
            immediate: false,
            deep: false
        },
    },
    data() {
        return {
            name: 'my name is mixins',
            dynamicData: true ? 'nums' : 'prices', //动态指令和参数
            loading: true, //控制加载数据时的状态
            operTitle: true, // true-- 添加 false-- 编辑
            isDialogShow: false, //控制弹框显示、隐藏
            isDialogDetailShow: false, //控制详情弹框显示、隐藏
            tableData: [], //数据源
            selectedData: [], //批量数据源
            // 分页参数
            pageParams: {
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },
        }
    },
    //本地过滤器
    filters: {
        numToString(value) {
            return value.toString();
        }
    },
    mounted() {
        this.getInitData();
    },
    computed: {
        getName() {
            return this.name + ' test'
        }
    },
    methods: {
        //批量操作事件
        handleSelectionChange(val) {
            this.selectedData = val;
        },
        //分页插件事件
        callFather(parm) {
            this.pageParams.currentPage = parm.currentPage;
            this.pageParams.pageSize = parm.pageSize;
            this.getInitData();
        },
        // 关闭详情
        closeDialog() {
            this.isDialogDetailShow = false;
        },
    }
}